import { render, staticRenderFns } from "./HistoryPrivilegeDetail.vue?vue&type=template&id=54a5b55a&scoped=true&"
import script from "./HistoryPrivilegeDetail.vue?vue&type=script&lang=js&"
export * from "./HistoryPrivilegeDetail.vue?vue&type=script&lang=js&"
import style0 from "./HistoryPrivilegeDetail.vue?vue&type=style&index=0&id=54a5b55a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54a5b55a",
  null
  
)

export default component.exports